import React, { useEffect, useState } from "react";
import { MenuItem, Table, TableBody, TableContainer, TableHead, TableRow, Paper, Container, Grid, Switch, FormControlLabel, Button, Tooltip, IconButton } from "@mui/material";
import {  FormControlBase, FormSectionBox, FormSectionTitle, InputLabelSelect, SelectBase, TextFieldBase } from "../../styles";
import { StyledTableCell } from "../acesso/acessoIndex";
import api from "../../../../Api/apiAxios";
import Mensagem from "../../../../Components/Mensagem";

import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Cancel, Check, Edit } from "@mui/icons-material";
import { sanitizeInscricao, formatInscricao } from "../../../../Utils/inscricaoFiscal";

export function InscricoesAdicionais({ clienteId, pedidoId }) {
  const [inscricoes, setInscricoes] = useState([]);
  const [novaInscricao, setNovaInscricao] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [saving, setSaving] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [tipoMensagem, setTipoMensagem] = useState("info");

  function showMensagem(msg, tipo = "info") {
    setTipoMensagem(tipo);
    setMensagem(msg);
  }

  const handleAddInscricao = () => {
    setNovaInscricao({
      tipoInscricao: 1,
      inscricaoAdicional: '',
      razaoSocial: '',
      status: true
    });
  };

  const handleSaveInscricao = async () => {
    if (!novaInscricao) return;

    const tipo = Number(novaInscricao.tipoInscricao);
    const inscricaoDigits = sanitizeInscricao(tipo, novaInscricao.inscricaoAdicional);

    if (!novaInscricao?.razaoSocial?.trim()) {
      showMensagem("Informe a Razão Social / Nome.", "danger");
      return;
    }

    if (!inscricaoDigits) {
      showMensagem("Informe a inscrição.", "danger");
      return;
    }

    if (inscricaoDigits.length > 14) {
      showMensagem("Campo Inscrição com tamanho inválido!", "danger");
      return;
    }

    if (tipo === 2 && inscricaoDigits.length !== 11) {
      showMensagem("CPF inválido!", "danger");
      return;
    }

    if (tipo === 1 && inscricaoDigits.length !== 14) {
      showMensagem("CNPJ inválido!", "danger");
      return;
    }

    const jaCadastrado = inscricoes.some((i) => {
      const tipoItem = Number(i.tipoInscricao);
      return tipoItem === tipo && sanitizeInscricao(tipoItem, i.inscricaoAdicional) === inscricaoDigits;
    });

    if (editIndex === null && jaCadastrado) {
      showMensagem(`${tipo === 1 ? "CNPJ" : "CPF"} já cadastrado para este cliente`, "info");
      return;
    }

    const regClienteCnpj = {
      ClienteId: clienteId,
      InscricaoAdicional: inscricaoDigits,
      TipoInscricao: tipo,
      RazaoSocial: novaInscricao.razaoSocial,
      AtestadoEmitido: 0,
      PedidoId: 0,
      Status: novaInscricao.status ? 1 : 0,
    };

    setSaving(true);
    try {
      const ret = await api.post("ClienteCnpj/", JSON.stringify(regClienteCnpj), { headers: { 'Content-Type': 'application/json'} });

      const ok = typeof ret?.data === "string" ? ret.data.match(/Sucesso/i) : true;
      if (!ok) {
        showMensagem("Não foi possível salvar a inscrição. Verifique os dados e tente novamente.", "danger");
        return;
      }

      await loadInscricoes();
      showMensagem(editIndex === null ? "Inscrição adicionada com sucesso!" : "Inscrição atualizada com sucesso!", "success");
      setNovaInscricao(null);
      setEditIndex(null);
    } catch (error) {
      const msg = error?.response?.data || error?.message || "Erro ao salvar a inscrição.";
      showMensagem(typeof msg === "string" ? msg : "Erro ao salvar a inscrição.", "danger");
    } finally {
      setSaving(false);
    }

  };

  const handleEditInscricao = (index) => {
    setEditIndex(index);
    setNovaInscricao(inscricoes[index]);
  };

  const handleSaveEditInscricao = async () => {
    await handleSaveInscricao();
  };

  const handleCancelEditInscricao = () => {
    setNovaInscricao(null);
    setEditIndex(null);
  };

  const loadInscricoes = React.useCallback(async () => {
    try {
      const resp = await api.get(`/ClienteCnpj/${clienteId}`);
      setInscricoes(resp.data);
    } catch (e) {
      console.log(e);
    }
  }, [clienteId]);
  
  useEffect(() => {
    loadInscricoes();
  }, [loadInscricoes]);

  const isSaveDisabled = !novaInscricao?.razaoSocial || !novaInscricao?.inscricaoAdicional;

  return (
    <FormSectionBox>
      {mensagem && <Mensagem mensagem={mensagem} setMensagem={setMensagem} variant={tipoMensagem} width="30rem" />}
      <FormSectionTitle label="Inscrições Adicionais" />
      <Container sx={{ my: 3 }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Tipo Inscrição</StyledTableCell>
                <StyledTableCell>Número Inscrição</StyledTableCell>
                <StyledTableCell>Razão Social</StyledTableCell>
                <StyledTableCell>Ativo</StyledTableCell>
                <StyledTableCell>Ações</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {inscricoes.map((inscricao, index) => (
                <TableRow key={`${Number(inscricao.tipoInscricao)}-${sanitizeInscricao(inscricao.tipoInscricao, inscricao.inscricaoAdicional) || index}`}>
                  <StyledTableCell>{inscricao.tipoInscricao === 1 ? "CNPJ" : "CPF"}</StyledTableCell>
                  <StyledTableCell>{formatInscricao(inscricao.tipoInscricao, inscricao.inscricaoAdicional)}</StyledTableCell>
                  <StyledTableCell>{inscricao.razaoSocial}</StyledTableCell>
                  <StyledTableCell>
                    <Switch checked={inscricao.status === 1} disabled />
                  </StyledTableCell>
                  <StyledTableCell>
                    <Tooltip title='Editar'>
                      <IconButton onClick={() => handleEditInscricao(index)}>
                        <Edit color="info"/>
                      </IconButton>
                    </Tooltip>
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <br />
        <Button onClick={handleAddInscricao} variant="text" sx={{ height: '2.5rem', fontSize: '0.78rem', color: 'rgb(19, 35, 80)', display: 'flex', alignItems: 'end' }}>
          <AddCircleIcon sx={{ marginRight: '0.5rem' }} />
          Nova Inscrição
        </Button>
      </Container>

      {novaInscricao && (
        <Container sx={{ my: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <FormControlBase>
                <InputLabelSelect>Tipo Inscrição</InputLabelSelect>
                <SelectBase
                  value={novaInscricao.tipoInscricao}              
                  label='Tipo Inscrição'
                  disabled={editIndex !== null}
                  onChange={(e) =>
                    setNovaInscricao({ ...novaInscricao, tipoInscricao: e.target.value })
                  }
                  width="100%"
                >
                  <MenuItem value={1}>CNPJ</MenuItem>
                  <MenuItem value={2}>CPF</MenuItem>
                </SelectBase>
              </FormControlBase>
            </Grid>
            <Grid item xs={3}>
              <TextFieldBase
                value={novaInscricao.inscricaoAdicional}
                label='Número Inscrição'
                disabled={editIndex !== null}
                onChange={(e) =>
                  setNovaInscricao({ ...novaInscricao, inscricaoAdicional: sanitizeInscricao(novaInscricao.tipoInscricao, e.target.value) })
                }
                width="100%"
              />
            </Grid>
            <Grid item xs={3}>
              <TextFieldBase
                label='Razão Social'
                value={novaInscricao.razaoSocial}
                onChange={(e) =>
                  setNovaInscricao({ ...novaInscricao, razaoSocial: e.target.value })
                }
                width="100%"
              />
            </Grid>
            <Grid item xs={1.5} sx={{ display: 'flex', alignItems: 'center' }}>
              <FormControlLabel 
                control={<Switch
                checked={novaInscricao.status}
                onChange={(e) =>
                  setNovaInscricao({ ...novaInscricao, status: e.target.checked })
                }
                />} 
                label="Ativo" 
              />
            </Grid>
            <Grid item xs={1.5} sx={{ display: 'flex', alignItems: 'center' }}>
              {editIndex === null ? (
                <Tooltip title='Salvar'>
                  <IconButton onClick={handleSaveInscricao} disabled={isSaveDisabled || saving}>
                    <Check color='success' />
                  </IconButton>
                </Tooltip>
              ) : (
                <>
                  <Tooltip title='Salvar'>
                    <IconButton onClick={handleSaveEditInscricao} disabled={isSaveDisabled || saving}>
                      <Check color='success' />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title='Cancelar'>
                    <IconButton onClick={handleCancelEditInscricao} disabled={saving}>
                      <Cancel color='error' />
                    </IconButton>
                  </Tooltip>
                </>
              )}
            </Grid>
          </Grid>
        </Container>
      )}
    </FormSectionBox>
  );
}
